import React, { Component } from 'react';
import TableRow from '../table/Row';
import TableColumn from '../table/Column';

class Field extends Component {
  render() {
    return (
      <TableRow>
        <TableColumn>
          <strong>{this.props.title}</strong>
        </TableColumn>
        <TableColumn>
          <this.props.editComponent {...this.props} />
        </TableColumn>
      </TableRow>
    );
  }
}

export { Field };
